class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-infinite-scroll-button]');
    this.spinner = this.querySelector('[data-infinite-scroll-spinner]');
    this.loading = false;

    if (!this.button) return;

    // Con JS activo el botón es solo un fallback: la carga es automática.
    this.button.addEventListener('click', this.onButtonClick);
    this.classList.add('infinite-scroll--auto');

    this.observer = new IntersectionObserver(this.onIntersection, { rootMargin: '600px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.button) this.button.removeEventListener('click', this.onButtonClick);
  }

  onIntersection = (entries) => {
    if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
  };

  onButtonClick = (event) => {
    event.preventDefault();
    this.loadNextPage();
  };

  async loadNextPage() {
    const url = this.button?.getAttribute('href');
    if (this.loading || !url) return;

    this.loading = true;
    this.setLoading(true);

    try {
      const sectionId = this.dataset.sectionId;
      const separator = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${separator}section_id=${sectionId}`);
      if (!response.ok) throw new Error(response.status);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = document.getElementById('product-grid');
      const newItems = html.querySelectorAll('#product-grid > li');
      if (!grid || newItems.length === 0) return this.finish();

      newItems.forEach((item) => grid.appendChild(item));

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(grid);
      }

      // La respuesta trae el enlace a la página siguiente, o ninguno si era la última.
      const nextUrl = html.querySelector('infinite-scroll [data-infinite-scroll-button]')?.getAttribute('href');
      if (!nextUrl) return this.finish();

      this.button.setAttribute('href', nextUrl);
    } catch (error) {
      console.error('Infinite scroll:', error);
      // Ante un fallo, devolvemos el botón para que el usuario pueda reintentar a mano.
      this.classList.remove('infinite-scroll--auto');
      if (this.observer) this.observer.disconnect();
    } finally {
      this.loading = false;
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.spinner?.classList.toggle('hidden', !isLoading);
  }

  finish() {
    if (this.observer) this.observer.disconnect();
    this.button.remove();
    this.button = null;
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
